import React from "react"

export default props => <p class="eyebrow" style={{ color: props.eyebrowColor }}>{props.eyebrowText}</p>
